import { Button, Form, Input, Row, Col } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../redux/alertsSlice";

//Function for Registration page
function Register() {
  //navigate to login page
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //onFinish function for registration
  const onFinish = async (values) => {
    try {
      //post request to register user
      dispatch(showLoading());

      // More flexible password validation
     const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

      // Password validation
   if (!passwordRegex.test(values.password)) {
      toast.error(
    "Password must be at least 8 characters long and include one uppercase letter, one lowercase letter, one number, and one special character."
     );
     dispatch(hideLoading());
     return;
       }


      const response = await axios.post("/api/user/register", values);
      dispatch(hideLoading());
      if (response.data.success) {
        //toast message
        toast.success(response.data.message);
        toast("Redirecting to OTP Verification Page");
        setTimeout(() => {
          navigate("/verify-otp");
        }, 3000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };
  //return statement
  return (
    <div className="auth">
      <div className="auth-bg">
        <h1 className="card-t">Registration Form</h1>
      
        <div className="auth-form card p-3">
          <h3 className="card-title">Enter your Registration Details</h3>
          <Form layout="vertical" onFinish={onFinish}>
            <div>
              <p className="mt-3">
                Create a free account or{" "}
                <Link to="/login" className="anchor">
                  Login
                </Link>
              </p>
            </div>
              <Row gutter={20}>
              <Col span={8} xs={24} sm={24} lg={24}>
            <Form.Item
              name="name"
              label="Full Name"
              rules={[
                {
                  message: "The input is not valid Full Nname",
                },
                {
                  required: true,
                  message: "Please input your Full Name",
                },
              ]}
            >
              <Input placeholder="Full Name" />
            </Form.Item>
            </Col>
            </Row>
            <Row gutter={20}>
            <Col span={6} xs={24} sm={24} lg={12}>
            <Form.Item
              name="email"
              label="Email Address "
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
            >
              <Input placeholder="Email Address" />
            </Form.Item>
            </Col>
            <Col span={8} xs={24} sm={24} lg={12}>
            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[
                {
                  message: "The input is not valid Phome Number!",
                },
                {
                  required: true,
                  message: "Please input your Phone Number!",
                },
              ]}
            >
              <Input placeholder="Phone Number" />
            </Form.Item>
            </Col>
            <Col span={8} xs={24} sm={24} lg={12}>

            <Form.Item
              name="password"
              label="Passcode"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password placeholder="Passcode" />
            </Form.Item>
</Col>
            <Col span={8} xs={24} sm={24} lg={12}>
            <Form.Item
              name="confirmPassword"
              label="Confirm Passcode"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password placeholder="Confirm Passcode" />
            </Form.Item>
            </Col>
            </Row>

            <Button className="btn-primary mt-3" htmlType="submit">
              Register
            </Button>
          </Form>
       
        </div>
      </div>
    </div>
  );
}

export default Register;
